var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopownericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 71,
    viewBox: "0 0 68 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5971 62.0384C52.5971 65.5664 49.7178 68.4561 46.198 68.4561H22.7345C19.2137 68.4561 16.3364 65.5664 16.3364 62.0384V6.41763C16.3364 2.88965 19.2147 0 22.7345 0H46.198C49.7178 0 52.5971 2.88965 52.5971 6.41763V62.0384Z",
    fill: "#04657B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.198 0H22.7345C19.2137 0 16.3364 2.88965 16.3364 6.41763V7.2211C16.3364 3.69312 19.2147 0.804489 22.7345 0.804489H46.198C49.7178 0.804489 52.5971 3.69312 52.5971 7.2211V6.41763C52.5971 2.88965 49.7188 0 46.198 0Z",
    fill: "#062A54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0455 67.1909H22.582C19.0622 67.1909 16.3354 64.057 16.3354 60.9688V62.0397C16.3354 65.5677 19.2137 68.4574 22.7335 68.4574H46.197C49.7168 68.4574 52.5961 65.5677 52.5961 62.0397V60.9688C52.5971 64.057 49.5673 67.1909 46.0455 67.1909Z",
    fill: "#ACBEED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1443 7.81055H18.7886V56.3693H50.1443V7.81055Z",
    fill: "url(#paint0_linear_254_957)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8648 9.09375H20.0691V55.0861H48.8648V9.09375Z",
    fill: "url(#paint1_linear_254_957)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0691 9.09375V55.0861H48.8648V9.09375H20.0691ZM47.796 54.0161H21.1349V10.1637H47.796V54.0161Z",
    fill: "url(#paint2_linear_254_957)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.8448 6.38515C28.883 6.38515 28.1021 5.60195 28.1021 4.63839C28.1021 3.67281 28.884 2.89062 29.8448 2.89062H39.0867C40.0495 2.89062 40.8335 3.6718 40.8335 4.63839C40.8335 5.60093 40.0495 6.38515 39.0867 6.38515H29.8448Z",
    fill: "url(#paint3_linear_254_957)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9789 4.63967C39.9789 5.13107 39.5788 5.52925 39.0868 5.52925H29.8448C29.3518 5.52925 28.9558 5.13107 28.9558 4.63967C28.9558 4.14523 29.3528 3.74805 29.8448 3.74805H39.0868C39.5788 3.74805 39.9789 4.14421 39.9789 4.63967Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0868 3.74805H29.8448C29.3518 3.74805 28.9558 4.14523 28.9558 4.63967C28.9558 5.13107 29.3528 5.52925 29.8448 5.52925H39.0868C39.5788 5.52925 39.9789 5.13107 39.9789 4.63967C39.9789 4.14421 39.5788 3.74805 39.0868 3.74805ZM39.0868 5.10168H29.8448C29.5892 5.10168 29.3811 4.89398 29.3811 4.63967C29.3811 4.38232 29.5892 4.17562 29.8448 4.17562H39.0868C39.3444 4.17562 39.5525 4.38232 39.5525 4.63967C39.5525 4.89297 39.3444 5.10168 39.0868 5.10168Z",
    fill: "url(#paint4_linear_254_957)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4666 66.2385C31.9116 66.2385 29.8335 64.1523 29.8335 61.5909C29.8335 59.0295 31.9116 56.9434 34.4666 56.9434C37.0216 56.9434 39.0987 59.0295 39.0987 61.5909C39.0987 64.1523 37.0216 66.2385 34.4666 66.2385Z",
    fill: "#C9D8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4664 65.0868C32.5429 65.0868 30.98 63.5194 30.98 61.5912C30.98 59.6641 32.5429 58.0957 34.4664 58.0957C36.39 58.0957 37.9519 59.6641 37.9519 61.5912C37.9519 63.5194 36.39 65.0868 34.4664 65.0868ZM34.4664 59.2447C33.1753 59.2447 32.1276 60.2984 32.1276 61.5902C32.1276 62.8831 33.1753 63.9358 34.4664 63.9358C35.7565 63.9358 36.8062 62.8841 36.8062 61.5902C36.8062 60.2984 35.7565 59.2447 34.4664 59.2447Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.7345 0C19.2137 0 16.3364 2.88965 16.3364 6.41763V7.2211V56.3695L46.199 0H22.7345Z",
    fill: "#306173"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4927 20.8763H11.178L20.0512 9.09375H25.8168L20.4927 20.8763Z",
    fill: "url(#paint5_linear_254_957)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8076 20.8763H20.4929L25.817 9.09375H31.5816L29.8076 20.8763Z",
    fill: "url(#paint6_linear_254_957)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1221 20.8763H29.8074L31.5814 9.09375H37.348L39.1221 20.8763Z",
    fill: "url(#paint7_linear_254_957)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4366 20.8763H39.1219L37.3479 9.09375H43.1125L48.4366 20.8763Z",
    fill: "url(#paint8_linear_254_957)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7524 20.8763H48.4367L43.1125 9.09375H48.8792L57.7524 20.8763Z",
    fill: "url(#paint9_linear_254_957)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8343 25.5468C18.4065 25.5468 20.4927 23.4556 20.4927 20.877H11.178C11.178 23.4556 13.2622 25.5468 15.8343 25.5468Z",
    fill: "url(#paint10_linear_254_957)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1498 25.5468C27.722 25.5468 29.8072 23.4556 29.8072 20.877H20.4915C20.4925 23.4556 22.5777 25.5468 25.1498 25.5468Z",
    fill: "url(#paint11_linear_254_957)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4645 25.5468C37.0376 25.5468 39.1228 23.4556 39.1228 20.877H29.8071C29.8081 23.4556 31.8933 25.5468 34.4645 25.5468Z",
    fill: "url(#paint12_linear_254_957)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7806 25.5468C46.3528 25.5468 48.438 23.4556 48.438 20.877H39.1233C39.1233 23.4556 41.2095 25.5468 43.7806 25.5468Z",
    fill: "url(#paint13_linear_254_957)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0969 25.5468C55.668 25.5468 57.7532 23.4556 57.7532 20.877H48.4375C48.4375 23.4556 50.5237 25.5468 53.0969 25.5468Z",
    fill: "url(#paint14_linear_254_957)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3159 35.8798V35.8811C29.3758 35.8713 29.4367 35.8756 29.4966 35.8874C29.5051 35.8891 29.5135 35.89 29.522 35.8921C29.5722 35.9044 29.6216 35.9273 29.6706 35.9535L29.6685 35.9467H30.0608V33.9798C30.0608 33.7172 30.1166 33.4686 30.2141 33.2425C30.2602 33.2052 30.3053 33.1743 30.351 33.14C30.397 33.1057 30.4434 33.068 30.4891 33.037C30.5258 33.0121 30.5621 32.9921 30.5989 32.9693C30.6538 32.9345 30.7091 32.8985 30.7636 32.8685C30.7973 32.8498 30.8303 32.8359 30.8636 32.8189C30.9207 32.7901 30.9777 32.7605 31.0338 32.7368C31.0655 32.7232 31.0968 32.7135 31.1284 32.7012C31.1859 32.6792 31.2433 32.6567 31.3007 32.6389C31.3311 32.6296 31.3611 32.6232 31.3915 32.6152C31.4494 32.6 31.5068 32.5843 31.5643 32.5733C31.5938 32.5678 31.6234 32.5644 31.6529 32.5597C31.7104 32.5508 31.7678 32.5419 31.8248 32.5368C31.8535 32.5343 31.8823 32.5339 31.911 32.5326C31.9688 32.5296 32.0263 32.5267 32.0837 32.5275C32.1111 32.528 32.1386 32.5296 32.166 32.5309C32.2243 32.5335 32.2822 32.536 32.34 32.5419C32.3666 32.5445 32.3932 32.5487 32.4203 32.5521C32.479 32.5593 32.5373 32.5678 32.5955 32.5783C32.6213 32.583 32.6471 32.5889 32.6728 32.594C32.7315 32.6063 32.7906 32.619 32.8493 32.6338C32.8747 32.6402 32.8996 32.6474 32.9249 32.6542C32.9845 32.6703 33.044 32.6876 33.1036 32.7063C33.1276 32.7139 33.1517 32.7219 33.1754 32.73C33.2362 32.7503 33.297 32.7706 33.3574 32.7931C33.3802 32.8016 33.403 32.81 33.4258 32.8189C33.4883 32.8426 33.5508 32.8668 33.6133 32.8922C33.6336 32.9007 33.6538 32.9087 33.6741 32.9172C33.7413 32.9451 33.8084 32.9735 33.876 33.0032C33.8895 33.0091 33.903 33.015 33.9165 33.0209C34.0787 33.0925 34.2417 33.1671 34.4056 33.2425C35.694 33.8371 37.0488 34.4665 38.7097 33.666C38.7271 33.7685 38.7414 33.8727 38.7414 33.9803L38.7237 35.9472H39.1426L39.1375 35.9645C39.1908 35.9323 39.2435 35.9052 39.2972 35.8913C39.2984 35.8908 39.2993 35.8908 39.3006 35.8908C39.3609 35.8752 39.4222 35.8713 39.4868 35.8819V35.8802C39.4898 35.8807 39.4927 35.8802 39.4952 35.8807C39.6705 35.909 39.817 36.0314 39.9273 36.2148C40.195 36.0302 40.3787 35.6736 40.3787 35.2585C40.3787 35.0014 40.3061 34.7685 40.1895 34.5821C40.4416 34.3919 40.6127 34.0459 40.6127 33.6457C40.6127 33.3179 40.497 33.0273 40.3175 32.8274C40.377 32.6681 40.4133 32.4911 40.4133 32.3009C40.4133 31.7381 40.119 31.2688 39.725 31.146C39.8365 30.4581 39.5818 29.8207 39.062 29.6229C38.858 29.5454 38.6401 29.5513 38.4272 29.6144C38.2097 28.9703 37.586 28.501 36.8414 28.501C36.7967 28.501 36.7544 28.5103 36.7105 28.5137C36.4174 27.8411 35.6421 27.3574 34.7214 27.3574C33.9782 27.3574 33.3266 27.6725 32.9482 28.1473C32.7159 28.0304 32.4553 27.9576 32.1745 27.9576C31.4507 27.9576 30.84 28.4002 30.6065 29.0164C30.4705 28.9457 30.3239 28.9033 30.1689 28.9033C29.503 28.9033 28.9628 29.6238 28.9628 30.5123C28.9628 30.5212 28.9649 30.5297 28.9649 30.5386C28.5021 30.6602 28.1524 31.204 28.1524 31.8571C28.1524 32.1366 28.2166 32.3962 28.326 32.6114C28.1009 32.8579 27.9543 33.2272 27.9543 33.6461C27.9543 34.0899 28.1174 34.48 28.3661 34.7253C28.3205 34.8892 28.2943 35.0692 28.2943 35.2593C28.2943 35.7845 28.4903 36.2343 28.7728 36.4558C28.883 36.1373 29.0726 35.9196 29.3159 35.8798Z",
    fill: "#3C3C3B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2994 46.3882L36.9977 44.2324C36.9977 46.0549 31.8126 46.0549 31.8126 44.2324L26.5113 46.3882C25.1988 46.8215 24.3115 48.051 24.3115 49.4373V54.31H25.1355H27.5181H28.1828H32.1923H33.3H35.5112H40.6283H41.293H43.6757H44.4996V49.4377C44.4992 48.0515 43.6124 46.8215 42.2994 46.3882Z",
    fill: "#F07436"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.998 44.2312V42.7734C36.4799 43.3753 36.0297 43.6353 35.2826 43.7277C35.033 43.7594 34.7501 43.7721 34.4203 43.7721C34.4169 43.7721 34.4131 43.7721 34.4097 43.7721C34.4084 43.7721 34.4068 43.7721 34.4055 43.7721C34.4042 43.7721 34.4025 43.7721 34.4013 43.7721C34.3979 43.7721 34.3941 43.7721 34.3907 43.7721C34.0609 43.7721 33.7779 43.7594 33.5279 43.7277C32.7813 43.6353 32.3307 43.3753 31.8125 42.7734V44.2312C31.8125 46.0533 36.998 46.0533 36.998 44.2312Z",
    fill: "#F2C28D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5056 35.8906H35.204C35.1727 35.8906 35.1453 35.9182 35.1453 35.9533V36.7436C35.1453 37.3264 35.6136 37.7961 36.1947 37.7961H36.5849C37.1702 37.7961 37.6462 37.3226 37.6462 36.736V36.0317C37.6462 35.9529 37.5837 35.8906 37.5056 35.8906ZM35.4109 37.1172C35.3535 37.0016 35.318 36.8732 35.318 36.7356V36.429L35.6453 36.0863H36.3957L35.4109 37.1172Z",
    fill: "#FFD2A1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7858 36.3389L29.6705 35.9548C29.6215 35.9285 29.5721 35.9056 29.5218 35.8934C29.5134 35.8912 29.5049 35.8904 29.4965 35.8887C29.4361 35.8769 29.3757 35.8726 29.3157 35.8824V35.8811C29.0725 35.9209 28.8833 36.1386 28.7731 36.4558C28.6662 36.7642 28.6341 37.1665 28.7034 37.5947C28.8166 38.299 29.1675 38.8505 29.5497 38.9953C29.6392 39.0305 29.733 39.0424 29.8225 39.0267C29.85 39.0229 29.877 39.011 29.9044 39.0034C29.8956 38.8882 29.8179 37.0869 29.7858 36.3389Z",
    fill: "#FFD2A1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3049 35.5006H33.6065C33.8536 35.5006 34.0495 35.7001 34.0537 35.947H34.7569C34.7611 35.7005 34.9571 35.5006 35.2041 35.5006H37.5057C37.768 35.5006 37.9766 35.6959 38.0188 35.947H38.7236L38.7414 33.9801C38.7414 33.8726 38.7274 33.7684 38.7097 33.6659C37.0488 34.4663 35.694 33.837 34.4055 33.2423C34.2417 33.1669 34.0787 33.092 33.9165 33.0208C33.903 33.0149 33.8895 33.009 33.8759 33.003C33.8084 32.9738 33.7412 32.945 33.6741 32.917C33.6538 32.9086 33.6335 32.9001 33.6133 32.8921C33.5508 32.8667 33.4883 32.8425 33.4258 32.8188C33.403 32.8103 33.3802 32.8014 33.3573 32.793C33.2965 32.7705 33.2357 32.7498 33.1753 32.7299C33.1513 32.7218 33.1276 32.7138 33.1035 32.7061C33.044 32.6875 32.9844 32.6705 32.9249 32.654C32.8996 32.6473 32.8746 32.6401 32.8493 32.6337C32.7906 32.6189 32.7319 32.6062 32.6728 32.5939C32.647 32.5888 32.6213 32.5829 32.5955 32.5782C32.5372 32.5676 32.4785 32.5596 32.4202 32.552C32.3936 32.5486 32.367 32.5443 32.34 32.5418C32.2821 32.5359 32.2239 32.5329 32.166 32.5308C32.1386 32.5295 32.1111 32.5278 32.0837 32.5274C32.0262 32.527 31.9688 32.5295 31.9109 32.5325C31.8822 32.5342 31.8535 32.5346 31.8248 32.5367C31.7678 32.5418 31.7103 32.5507 31.6529 32.5596C31.6233 32.5642 31.5942 32.5672 31.5642 32.5731C31.5068 32.5841 31.4493 32.5998 31.3915 32.6151C31.3611 32.6231 31.3311 32.6295 31.3007 32.6388C31.2437 32.6561 31.1862 32.679 31.1284 32.701C31.0967 32.7133 31.0655 32.7231 31.0338 32.7366C30.9776 32.7608 30.9206 32.7904 30.8636 32.8188C30.8302 32.8357 30.7969 32.8497 30.7635 32.8683C30.709 32.8984 30.6537 32.9348 30.5988 32.9691C30.5621 32.992 30.5258 33.0119 30.489 33.0369C30.4434 33.0678 30.397 33.1055 30.3509 33.1398C30.3053 33.1737 30.2601 33.2046 30.2141 33.2423C30.1161 33.4685 30.0608 33.7171 30.0608 33.9797V35.9466H30.7918C30.8345 35.6959 31.0431 35.5006 31.3049 35.5006Z",
    fill: "#FFD2A1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6065 35.8906H31.3049C31.2268 35.8906 31.1643 35.9533 31.1643 36.0312V36.7356C31.1643 37.3222 31.6403 37.7957 32.2252 37.7957H32.6154C33.1965 37.7957 33.6648 37.3264 33.6648 36.7432V35.9529C33.6652 35.9177 33.6378 35.8906 33.6065 35.8906ZM31.4527 37.1172C31.3953 37.0016 31.3598 36.8732 31.3598 36.7356V36.429L31.6871 36.0863H32.4376L31.4527 37.1172Z",
    fill: "#FFD2A1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0362 36.7349C38.0362 37.5371 37.3846 38.1864 36.5851 38.1864H36.1949C35.3993 38.1864 34.7557 37.5409 34.7557 36.743V36.3364H34.0551V36.743C34.0551 37.5409 33.4115 38.1864 32.6158 38.1864H32.2256C31.4258 38.1864 30.7746 37.5371 30.7746 36.7349V36.3359H30.0925C30.1601 36.9856 30.3273 38.4617 30.5013 39.0195C30.6808 39.5946 31.6834 40.5882 32.4165 40.1423C33.2476 39.6454 34.0196 39.5751 34.3824 39.5552C34.3895 39.5557 34.3971 39.5561 34.4047 39.5565C34.4123 39.5561 34.4199 39.5557 34.4271 39.5552C34.7899 39.5747 35.5623 39.645 36.393 40.1423C37.1265 40.5882 38.1287 39.5946 38.3082 39.0195C38.4826 38.4617 38.6494 36.9856 38.717 36.3359H38.0362V36.7349Z",
    fill: "#FFD2A1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4951 35.8797C39.4922 35.8793 39.4896 35.8797 39.4867 35.8793V35.881C39.4221 35.8704 39.3608 35.8742 39.3004 35.8899C39.2992 35.8903 39.2983 35.8903 39.2971 35.8903C39.2434 35.9047 39.1906 35.9318 39.1374 35.9636L39.0251 36.3375C38.993 37.0855 38.9157 38.8868 38.906 39.0016C38.9335 39.0092 38.9605 39.0211 38.9879 39.0249C39.0779 39.0406 39.1712 39.0287 39.2612 38.9935C39.6434 38.8487 39.9947 38.2972 40.1075 37.5929C40.1966 37.0419 40.118 36.5328 39.9272 36.2139C39.8169 36.0305 39.6704 35.9081 39.4951 35.8797Z",
    fill: "#FFD2A1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5279 43.7258C33.7758 43.7563 34.0562 43.7686 34.3827 43.7686C34.3903 43.7686 34.3979 43.7686 34.4051 43.7686C34.4127 43.7686 34.4199 43.7686 34.4275 43.7686C34.7539 43.7686 35.0343 43.7563 35.2822 43.7258C36.0289 43.6335 36.4795 43.3734 36.9976 42.7716L36.9981 42.7711C37.3021 42.415 37.6298 41.9457 38.0551 41.3197C38.4141 40.7915 38.6949 40.0012 38.9056 39C38.9149 38.8852 38.9926 37.0839 39.0247 36.3359H38.7181C38.6506 36.9856 38.4837 38.4617 38.3093 39.0195C38.1298 39.5946 37.1273 40.5882 36.3942 40.1423C35.5635 39.6454 34.7911 39.5751 34.4283 39.5552C34.4211 39.5557 34.4135 39.5561 34.4059 39.5565C34.3983 39.5561 34.3907 39.5557 34.3835 39.5552C34.0208 39.5747 33.2484 39.645 32.4177 40.1423C31.6845 40.5882 30.682 39.5946 30.5025 39.0195C30.3281 38.4617 30.1613 36.9856 30.0937 36.3359H29.7871C29.8192 37.0839 29.8965 38.8852 29.9058 39C30.1165 40.0016 30.3973 40.7915 30.7563 41.3197C31.1816 41.9457 31.5093 42.415 31.8134 42.7711L31.8138 42.7716C32.3307 43.3734 32.7813 43.6335 33.5279 43.7258ZM33.6901 40.3235H35.1205C35.4461 40.3235 35.71 40.5535 35.71 40.8369C35.71 41.1206 35.4461 41.3502 35.1205 41.3502H33.6901C33.3645 41.3502 33.1006 41.1202 33.1006 40.8369C33.101 40.5535 33.3645 40.3235 33.6901 40.3235Z",
    fill: "#FFD2A1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.5279 43.7258C33.7758 43.7563 34.0562 43.7686 34.3827 43.7686C34.3903 43.7686 34.3979 43.7686 34.4051 43.7686C34.4127 43.7686 34.4199 43.7686 34.4275 43.7686C34.7539 43.7686 35.0343 43.7563 35.2822 43.7258C36.0289 43.6335 36.4795 43.3734 36.9976 42.7716L36.9981 42.7711C37.3021 42.415 37.6298 41.9457 38.0551 41.3197C38.4141 40.7915 38.6949 40.0012 38.9056 39C38.9149 38.8852 38.9926 37.0839 39.0247 36.3359H38.7181C38.6506 36.9856 38.4837 38.4617 38.3093 39.0195C38.1298 39.5946 37.1273 40.5882 36.3942 40.1423C35.5635 39.6454 34.7911 39.5751 34.4283 39.5552C34.4211 39.5557 34.4135 39.5561 34.4059 39.5565C34.3983 39.5561 34.3907 39.5557 34.3835 39.5552C34.0208 39.5747 33.2484 39.645 32.4177 40.1423C31.6845 40.5882 30.682 39.5946 30.5025 39.0195C30.3281 38.4617 30.1613 36.9856 30.0937 36.3359H29.7871C29.8192 37.0839 29.8965 38.8852 29.9058 39C30.1165 40.0016 30.3973 40.7915 30.7563 41.3197C31.1816 41.9457 31.5093 42.415 31.8134 42.7711L31.8138 42.7716C32.3307 43.3734 32.7813 43.6335 33.5279 43.7258ZM33.6901 40.3235H35.1205C35.4461 40.3235 35.71 40.5535 35.71 40.8369C35.71 41.1206 35.4461 41.3502 35.1205 41.3502H33.6901C33.3645 41.3502 33.1006 41.1202 33.1006 40.8369C33.101 40.5535 33.3645 40.3235 33.6901 40.3235Z",
    fill: "#3C3C3B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6901 41.3509H35.1205C35.4461 41.3509 35.71 41.1209 35.71 40.8375C35.71 40.5542 35.4461 40.3242 35.1205 40.3242H33.6901C33.3645 40.3242 33.1006 40.5542 33.1006 40.8375C33.101 41.1209 33.3645 41.3509 33.6901 41.3509Z",
    fill: "#FFD2A1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1373 35.9638L39.1424 35.9464H38.7235H38.0186C37.976 35.6952 37.7678 35.5 37.5055 35.5H35.2039C34.9569 35.5 34.7609 35.6995 34.7567 35.9464H34.054C34.0497 35.6999 33.8538 35.5 33.6067 35.5H31.3052C31.0429 35.5 30.8343 35.6952 30.792 35.9464H30.061H29.6687L29.6708 35.9532L29.7861 36.3373H30.0927H30.7747V36.7363C30.7747 37.5385 31.4259 38.1878 32.2258 38.1878H32.616C33.4116 38.1878 34.0552 37.5423 34.0552 36.7443V36.3378H34.7559V36.7443C34.7559 37.5423 35.3995 38.1878 36.1951 38.1878H36.5853C37.3852 38.1878 38.0364 37.5385 38.0364 36.7363V36.3373H38.7184H39.025L39.1373 35.9638ZM33.6654 36.7443C33.6654 37.3271 33.1975 37.7968 32.616 37.7968H32.2258C31.6405 37.7968 31.1649 37.3233 31.1649 36.7367V36.0324C31.1649 35.954 31.2274 35.8918 31.3056 35.8918H33.6072C33.6384 35.8918 33.6659 35.9193 33.6659 35.9545L33.6654 36.7443ZM37.6466 36.7367C37.6466 37.3233 37.1706 37.7968 36.5853 37.7968H36.1951C35.614 37.7968 35.1456 37.3276 35.1456 36.7443V35.954C35.1456 35.9189 35.1731 35.8914 35.2043 35.8914H37.5059C37.5841 35.8914 37.6466 35.954 37.6466 36.032V36.7367Z",
    fill: "#575756"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3596 36.431V36.7376C31.3596 36.8753 31.3951 37.0036 31.4525 37.1192L32.4374 36.0879H31.6869L31.3596 36.431Z",
    fill: "#F6F6F6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3179 36.431V36.7376C35.3179 36.8753 35.3533 37.0036 35.4108 37.1192L36.3956 36.0879H35.6452L35.3179 36.431Z",
    fill: "#F6F6F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_254_957",
    x1: 34.4664,
    y1: 56.3695,
    x2: 34.4664,
    y2: 7.81095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CCD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0437,
    stopColor: "#B4D0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#C1DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#C9E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE3EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_254_957",
    x1: 34.4669,
    y1: 55.0857,
    x2: 34.4669,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4182,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6494,
    stopColor: "#E7F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_254_957",
    x1: 34.4669,
    y1: 55.0857,
    x2: 34.4669,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CCD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0437,
    stopColor: "#B4D0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#C1DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#C9E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE3EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_254_957",
    x1: 34.4675,
    y1: 6.38535,
    x2: 34.4675,
    y2: 2.89164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CCD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0437,
    stopColor: "#B4D0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#C1DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#C9E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE3EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_254_957",
    x1: 34.4672,
    y1: 5.52875,
    x2: 34.4672,
    y2: 3.74774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CCD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0437,
    stopColor: "#B4D0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#C1DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#C9E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE3EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_254_957",
    x1: 18.4972,
    y1: 20.8763,
    x2: 18.4972,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#05748D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#06829E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#3EAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#158AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#066277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#047792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_254_957",
    x1: 26.0373,
    y1: 20.8763,
    x2: 26.0373,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC935E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_254_957",
    x1: 34.4646,
    y1: 20.8763,
    x2: 34.4646,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#05748D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#06829E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#3EAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#158AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#066277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#047792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_254_957",
    x1: 42.8923,
    y1: 20.8763,
    x2: 42.8923,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC935E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_254_957",
    x1: 50.4323,
    y1: 20.8763,
    x2: 50.4323,
    y2: 9.09375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#05748D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#06829E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#3EAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#158AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#066277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#047792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_254_957",
    x1: 15.8351,
    y1: 25.5471,
    x2: 15.8351,
    y2: 20.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04657B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1087A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_254_957",
    x1: 25.1501,
    y1: 25.5471,
    x2: 25.1501,
    y2: 20.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_254_957",
    x1: 34.4648,
    y1: 25.5471,
    x2: 34.4648,
    y2: 20.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04657B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1087A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_254_957",
    x1: 43.7814,
    y1: 25.5471,
    x2: 43.7814,
    y2: 20.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_254_957",
    x1: 53.0951,
    y1: 25.5471,
    x2: 53.0951,
    y2: 20.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04657B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1087A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopownericon);
export default __webpack_public_path__ + "static/media/shop owner icon.80913661e53fdb5f73b2ca4e19090bd1.svg";
export { ForwardRef as ReactComponent };